import AlertTriangle from '@asset/svg/AlertTriangle';
import CloseIcon from '@asset/svg/CloseIcon';
import React from 'react';

const NoticeBanner = ({
  content,
  onClose,
}: {
  content: React.ReactNode | string;
  onClose: () => void;
}) => {
  return (
    <div className="flex items-center justify-between h-12 px-6 py-3 bg-my-cyan-95">
      <div></div>
      <div className="flex items-center gap-1 text-my-gray-10 text-label-lg-600">
        <AlertTriangle width="16" height="16" color="var(--red-50)" />
        {content}
      </div>

      <CloseIcon
        width="24"
        height="24"
        color="var(--gray-10)"
        onClick={onClose}
      />
    </div>
  );
};

export default NoticeBanner;
